import actionTypes from "../actionTypes";


const update = require('immutability-helper');


export const initialState = {
    contacta: false as boolean,
    forget_pass: false as boolean,
    user: '' as string,
    password: '' as string,
    error: null as null | string,
    view: false as boolean,
    hover: '' as string,
    submit: false as boolean,
    recover_email: '' as string,
    go2app: false as boolean
};

export function reducer(state: typeof initialState=initialState, action: actionTypes) {
    switch (action.type) {
        case 'set-login-contacta':
            return update(state, {contacta: {$set: action.contacta}});

        case 'set-login-forget-pass':
            return update(state, {forget_pass: {$set: action.forget_pass}});

        case 'set-login-user':
            return update(state, {user: {$set: action.user}});

        case 'set-login-password':
            return update(state, {password: {$set: action.password}});

        case 'set-login-error':
            return update(state, {error: {$set: action.error}});

        case 'set-login-view':
            return update(state, {view: {$set: action.view}});

        case 'set-login-hover':
            return update(state, {hover: {$set: action.hover}});

        case 'set-login-submit':
            return update(state, {submit: {$set: action.submit}});

        case 'set-login-email-recover':
            return update(state, {recover_email: {$set: action.email}});

        case 'set-go-to-app':
            return update(state, {go2app: {$set: action.go2app}});

        default:
            return state
    }
}
